import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  OrderDetailsProvider,
  useOrderDetails,
} from "../../context/OrderDetailContext";
import { CustomerCard } from "../../components/cards/CustomerCard";
import { PaymentDetailsCard } from "../../components/cards/PaymentDetailsCard";
import { ShippingCard } from "../../components/cards/ShippingCard";
import { getOrderDetails } from "../../services/orders/orderAxios";
import { ProductDetail } from "../../components/cards/ProductDetail";
import { TopNavBarComponent } from "../../components/navbar/TopNavBarComponent";
import Loader from "../../components/common/Loader";
import { useAuth } from "../../context/AuthContext";
import { IntegrationCardInfo } from "../../components/cards/IntegrationCardInfo";
import { DropiState, ShopifyState } from "../SalesPage/SalesPageInterface";
import { dictionary } from "../../utils/dictionary";
import { CustomerFieldsCard } from "../../components/cards/CustomerFieldsCard";
import { handleApi } from "../../utils/handleApi";

const OrderDetailsContent = () => {
  const { language } = useAuth();
  const {
    products,
    customer,
    paymentDetails,
    shippingAddress,
    orderDetails,
    loading,
    error,
    setOrderDetailsData,
    setLoadingState,
    setErrorState,
  } = useOrderDetails();

  const { hash_id } = useParams();
  const dataLoadedRef = useRef(false);
  const [errorOrderDetails, setErrorOrderDetails] = useState<string>();

  
  useEffect(() => {
    if (dataLoadedRef.current || !hash_id) {
      if (!hash_id) {
        setErrorState("No order ID provided");
      }
      return;
    }

    const fetchOrderDetails = async () => {
      setLoadingState(true);
      const { res, error } = await handleApi(getOrderDetails(hash_id), false);
      
      if (error) {
        setErrorState("Failed to load order details");
        setLoadingState(false);
        return;
      }

      if (res) {
        if (!!res.dropi_integration_error) {
          setErrorOrderDetails(res.dropi_integration_error);
        }
        setOrderDetailsData(res);
        setLoadingState(false);
        dataLoadedRef.current = true;
      }
    };

    fetchOrderDetails();
  }, [hash_id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <TopNavBarComponent />
      <div className="flex flex-row md:flex-row">
        {/* Main content column - takes up 70% of the space */}
        <div className="m-6 md:w-[70%]">
          {orderDetails && (
            <ProductDetail order={orderDetails} products={products} />
          )}
        </div>

        {/* Sidebar column - takes up 30% of the space */}
        <div className="m-6 md:w-[30%] space-y-4 flex flex-col gap-4">
          {customer && <CustomerCard customer={customer} />}
          {paymentDetails && (
            <PaymentDetailsCard paymentDetails={paymentDetails} />
          )}
          {shippingAddress && (
            <ShippingCard shippingAddress={shippingAddress} />
          )}
          {customer?.custom_fields && (
            <CustomerFieldsCard customFields={customer?.custom_fields} />
          )}

          {orderDetails?.dropi_state === DropiState.SUCCESS &&
            orderDetails?.dropi_url && (
              <IntegrationCardInfo
                title={dictionary["integration-dropi"][language]}
                description={
                  dictionary["integration-dropi-description-success"][language]
                }
                buttonText={
                  dictionary["integration-dropi-button-text"][language]
                }
                buttonLink={orderDetails?.dropi_url}
              />
            )}
          {orderDetails?.dropi_state === DropiState.ERROR && (
            <IntegrationCardInfo
              title={dictionary["integration-dropi"][language]}
              description={
                dictionary["integration-dropi-description-error"][language]
              }
              error={errorOrderDetails}
            />
          )}

          {orderDetails?.shopify_integration_state === ShopifyState.SUCCESS && (
              <IntegrationCardInfo
                title={dictionary["integration-shopify"][language]}
                description={
                  dictionary["integration-shopify-description-success"][language]
                }
                // buttonText={
                //   dictionary["integration-shopify-button-text"][language]
                // }
                // buttonLink={orderDetails?.dropi_url}
              />
            )}
          {orderDetails?.shopify_integration_state === ShopifyState.ERROR && (
            <IntegrationCardInfo
              title={dictionary["integration-shopify"][language]}
              description={
                dictionary["integration-shopify-description-error"][language]
              }
            />
          )}

        </div>
      </div>
    </div>
  );
};

// Este componente solo proporciona el contexto
export const OrderDetailsPage = () => {
  const { hash_id } = useParams();

  return (
    <OrderDetailsProvider hashId={hash_id}>
      <OrderDetailsContent />
    </OrderDetailsProvider>
  );
};
